
import React from 'react';
import * as styles from '@/pages/home/components/RegionSelect/index.module.less';
import { importImg } from '../utils';

const regionSelectInput = (props:any) => {
  // const { getLocalText } = useLocal('selector_multiple_component')
  const { globalText,resultLength,showChinese,result, resultLable} = props;

  return (
    <span className={styles['region-container']} id='region-input'>
          {(globalText && <span className={styles['region-value-box']} dangerouslySetInnerHTML={{ __html: `${globalText}` }}></span>) || (
            <>
              {resultLength?.regions === 0 && resultLength?.markets === 0 && result?.regions?.length === 1 && result?.regions[0] === 'Unidentified'
                ? `${showChinese ? '地区 ' : ''}<span class={${styles['region-value-left']}}>${resultLable[0]}</span> Unidentified`
                : <>
                  <span className={styles['region-value-box']}>
                    {resultLength?.regions !== null && (
                      <>
                        {/* 选择一个region时，显示具体的region名称 */}
                        {resultLength?.regions === 1 && !resultLength?.markets && result?.regionMarketNames?.length
                          ? (result?.regions?.includes('Unidentified')
                            ? <>{showChinese ? '地区 ' : ''}<span className={styles['region-value-left']}>{resultLable[0]}</span> {result?.regionMarketNames[1]}</>
                            : <>{showChinese ? '地区 ' : ''}<span className={styles['region-value-left']}>{resultLable[0]}</span> {result?.regionMarketNames[0]}</>
                          )
                          // 只多选region，展示region数
                          : (resultLength?.regions >= 1 && !resultLength?.markets
                            ? <>
                              {showChinese ? '地区 ' : ''}<span className={styles['region-value-left']}>{resultLable[0]}</span>
                              {resultLength?.regions == 0 ? '' : resultLength?.regions}
                            </>
                            : (showChinese ? '地区 ' : '')
                          )}
                      </>
                    )}
                  </span>
                  {resultLength?.regions === null ||
                    resultLength?.markets === null || (showChinese && <>/</>)}
                  <span>
                    {resultLength?.markets !== null && (
                      <>
                        {/* 选择一个Market时，显示具体的国家名和国旗 */}
                        {resultLength?.markets === 1 && !resultLength?.regions && result?.regionMarketNames?.length && result?.regions?.length
                          ? <>
                            {showChinese ? '国家 ' : ''}<span className={styles['region-market-title']}>{resultLable[1]}</span> <img style={{ width: '18px', marginRight: '4px', marginBottom: '-1px' }} src={importImg(`${result?.regions[0]?.toLowerCase()}`)} />
                            {result?.regionMarketNames[0]}
                          </>
                          // 只多选market，展示region数
                          : (resultLength?.markets >= 1 && !resultLength?.regions
                            ? <>
                              {showChinese ? '国家 ' : ''}<span className={styles['region-market-title']}>{resultLable[1]}</span>
                              {resultLength?.markets == 0 ? '' : resultLength?.markets}
                            </>
                            // 多选多个regin下的market，展示region数和market数
                            : <>
                              {showChinese ? ' 国家 ' : ''}<span className={styles['region-market-title']}>{resultLable[0]}</span> {resultLength?.regions == 0 ? '' : resultLength?.regions} <span className={styles['region-market-split']}>/</span> <span className={styles['region-market-title']}>{resultLable[1]}</span> {resultLength?.markets == 0 ? '' : resultLength?.markets}
                            </>
                          )}
                      </>
                    )}
                  </span>
                </>
              }
            </>
          )}
        </span>
  )
}

export default regionSelectInput